module.exports = __webpack_public_path__ + "img/delfault.e79c1aec.jpg";